export const resultsSelector = state => state.find.results || {found:0}
